import objects from './country-list.fr.json'

const countries = [];

for (const key in objects) {
    countries.push(objects[key])
}

export default countries;
